// extracted by mini-css-extract-plugin
export default {"container":"Avatar_container__p3aME","img":"Avatar_img__iHPNz","title":"Avatar_title__p01ge","md":"Avatar_md__sO5Jh","sm":"Avatar_sm__I85R8"};